import { OPS_AUTH, USE_MOCK_AUTH } from "../config/api";
import { apiRequest, unwrapApiEnvelope } from "./apiClient";

/** Institution routes bind by numeric provider / institution id. */
function institutionBase(institutionId) {
  return `${OPS_AUTH.institutions}/${encodeURIComponent(institutionId)}`;
}

export async function fetchInstitutionOpsAssignments(token, institutionId) {
  if (USE_MOCK_AUTH || !token) return [];
  const json = await apiRequest(`${institutionBase(institutionId)}/ops-assignments`, {
    method: "GET",
    token,
  });
  const data = unwrapApiEnvelope(json);
  return Array.isArray(data?.assignments) ? data.assignments : [];
}

export async function addInstitutionOpsAssignment(token, institutionId, adminId) {
  const json = await apiRequest(`${institutionBase(institutionId)}/ops-assignments`, {
    method: "POST",
    token,
    body: { admin_id: Number(adminId) },
  });
  return unwrapApiEnvelope(json);
}

export async function removeInstitutionOpsAssignment(token, institutionId, adminId) {
  const json = await apiRequest(`${institutionBase(institutionId)}/ops-assignments/${adminId}`, {
    method: "DELETE",
    token,
  });
  return unwrapApiEnvelope(json);
}

export async function fetchInstitutionSlaSettings(token, institutionId) {
  if (USE_MOCK_AUTH || !token) return { effective: null, history: [] };
  const json = await apiRequest(`${institutionBase(institutionId)}/sla-settings`, {
    method: "GET",
    token,
  });
  const data = unwrapApiEnvelope(json);
  return {
    effective: data?.effective ?? null,
    history: Array.isArray(data?.history) ? data.history : [],
  };
}

export async function createInstitutionSlaSetting(token, institutionId, payload) {
  const json = await apiRequest(`${institutionBase(institutionId)}/sla-settings`, {
    method: "POST",
    token,
    body: payload,
  });
  return unwrapApiEnvelope(json);
}
